import {
    CAPTIONS_LISTS,
    CONTENT_ALBUMS,
    CONTENT_POSTS,
    DASHBOARD,
    GROUPS,
    INSPIRATION,
    PLATFORM_OPTIONS,
    REPORTS,
    SCHEDULER,
    SCHEDULER_COLLABORATION_SETTINGS,
    SOCIAL_PROFILES,
    USERS_ROLES
} from '@/lib/routes/privateRoutes';

export const maxDisplayedTasks = 4;

export type TaskType = {
    url: string;
};

export const onboardingTasks: Record<string, TaskType> = {
    'create-album': {
        url: CONTENT_ALBUMS
    },
    'use-labels': {
        url: CONTENT_POSTS
    },
    'schedule-post': {
        url: SCHEDULER
    },
    'share-collaboration-link': {
        url: SCHEDULER_COLLABORATION_SETTINGS
    },
    'save-caption-hashtag-list': {
        url: CAPTIONS_LISTS
    },
    'use-caption-ai': {
        url: SCHEDULER
    },
    'schedule-report': {
        url: REPORTS
    },
    'create-dashboard': {
        url: DASHBOARD
    },
    'share-dashboard': {
        url: DASHBOARD
    },
    'generate-customized-report': {
        url: DASHBOARD
    },
    'invite-user': {
        url: USERS_ROLES
    },
    'add-social-profile': {
        url: SOCIAL_PROFILES
    },
    'create-group': {
        url: GROUPS
    },
    'change-homepage': {
        url: PLATFORM_OPTIONS
    },
    'content-inspiration': {
        url: INSPIRATION
    }
};
